module.exports = __webpack_public_path__ + "2c41de9dfc5704e3d90896a7c9ce9214.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileApp/app-store.png
// module id = 1332
// module chunks = 47